const { roleCodes, isPlatformSuperAdmin } = require('./roomAccessUi.cjs')

const PRODUCTION_SKILLS = new Set(['space-intelligence-design', 'device-intelligence-design'])

function isProductionWorker(user = {}) {
  return !isPlatformSuperAdmin(user) && roleCodes(user).includes('production_worker')
}

function canUseProduction(user = {}) {
  return Boolean(user.token) && isPlatformSuperAdmin(user)
}

function productionRouteAllowed(path = '') {
  return path === '/workbench'
}

module.exports = { PRODUCTION_SKILLS, isProductionWorker, canUseProduction, productionRouteAllowed }
